<template>
    <div class="o-media" v-bind:class="{'o-media--big-image': $route.meta.slideshow_type == 'big-image' }">
        <img class="o-media__image" :src="$route.meta.image">
    </div>
</template>

<script>
export default {

}
</script>
